import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getWareHouseStoreChallan = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/v1/challan',
    headers:  getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getWareHouseStoreChallanQrCode = data => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/warehouse/api/secure/v1/challan-qr-code',
    headers:  getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getWareHouseStoreChallanQrCodeNewReceipt = challanId => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/store/1/challan-qrcode-print-view/' + challanId,
    headers:  getHeaders(),
  });
};

export const getChallanText = challanId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/v1/challan/' +
      challanId +
      '/download/txt',
    headers:  getHeaders(),
  });
};

export const DeleteChallan = challanId => {
  return axios({
    method: 'delete',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/v1/delete-challan/' +
      challanId,
    headers: getHeaders(),
  });
};
